module.exports = __webpack_public_path__ + "img/imagexclose.b4ab4b1a.svg";